(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leak-repair-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('leak-repair-section')) {
    customElements.define(
      'leak-repair-section',
      class extends HTMLElement {

        connectedCallback() {
          this.frame = requestAnimationFrame(() => this.init());
        }

        init() {
          if (this.controller) return;

          this.track = this.querySelector('[data-track]');
          this.slides = [...this.querySelectorAll('[data-slide]')];

          if (!this.track || this.slides.length < 2) return;

          this.controller = new AbortController();

          const on = (target, event, handler) => {
            if (target) {
              target.addEventListener(event, handler, {
                signal: this.controller.signal
              });
            }
          };

          this.dots = [...this.querySelectorAll('[data-dot]')];
          this.playButton = this.querySelector('[data-play]');
          this.reducedMotion = matchMedia(
            '(prefers-reduced-motion: reduce)'
          );

          this.index = 0;
          this.visible = true;
          this.hovered = false;
          this.selected = false;
          this.dragging = false;
          this.scrolling = false;

          this.playing =
            this.dataset.autoplay === 'true' &&
            !this.reducedMotion.matches;

          this.querySelector('[data-controls]').hidden = false;

          on(
            this.querySelector('[data-prev]'),
            'click',
            () => this.go(this.index - 1)
          );

          on(
            this.querySelector('[data-next]'),
            'click',
            () => this.go(this.index + 1)
          );

          this.dots.forEach((dot, index) => {
            on(dot, 'click', () => this.go(index));
          });

          on(this.playButton, 'click', () => {
            this.playing = !this.playing;
            this.update();
          });

          on(this, 'pointerenter', (event) => {
            if (event.pointerType === 'mouse') {
              this.hovered = true;
            }
          });

          on(this, 'pointerleave', () => {
            this.hovered = false;
          });

          on(this.track, 'pointerdown', () => {
            this.dragging = true;
          });

          on(document, 'pointerup', () => {
            this.dragging = false;
          });

          on(document, 'pointercancel', () => {
            this.dragging = false;
          });

          on(this.track, 'keydown', (event) => {
            if (
              !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(
                event.key
              )
            ) {
              return;
            }

            event.preventDefault();

            let next =
              this.index +
              (event.key === 'ArrowLeft' ? -1 : 1);

            if (event.key === 'Home') {
              next = 0;
            }

            if (event.key === 'End') {
              next = this.slides.length - 1;
            }

            this.go(next);
          });

          on(this.track, 'scroll', () => {
            this.scrolling = true;
            clearTimeout(this.scrollTimer);

            this.scrollTimer = setTimeout(() => {
              this.index = this.slides.reduce(
                (best, slide, index) => {
                  const distance = Math.abs(
                    slide.offsetLeft - this.track.scrollLeft
                  );

                  const previous = Math.abs(
                    this.slides[best].offsetLeft -
                    this.track.scrollLeft
                  );

                  return distance < previous ? index : best;
                },
                0
              );

              this.scrolling = false;
              this.update();
            }, 120);
          });

          on(document, 'shopify:block:select', (event) => {
            if (
              event.detail.sectionId !== this.dataset.sectionId
            ) {
              return;
            }

            const index = this.slides.findIndex(
              slide =>
                slide.dataset.blockId === event.detail.blockId
            );

            if (index !== -1) {
              this.selected = true;
              this.go(index, false);
            }
          });

          [
            'shopify:section:select',
            'shopify:section:deselect',
            'shopify:block:deselect'
          ].forEach(eventName => {
            on(document, eventName, (event) => {
              if (
                event.detail.sectionId === this.dataset.sectionId
              ) {
                this.selected =
                  eventName === 'shopify:section:select';
              }
            });
          });

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(() => {
              this.go(this.index, false);
            });

            this.resizeObserver.observe(this.track);
          }

          if ('IntersectionObserver' in window) {
            this.visibilityObserver = new IntersectionObserver(
              entries => {
                this.visible = entries[0].isIntersecting;
              }
            );

            this.visibilityObserver.observe(this.track);
          }

          if (this.dataset.autoplay === 'true') {
            this.timer = setInterval(() => {
              if (
                !this.playing ||
                this.hovered ||
                this.selected ||
                this.dragging ||
                this.scrolling ||
                !this.visible ||
                document.hidden ||
                this.matches(':focus-within') ||
                this.reducedMotion.matches
              ) {
                return;
              }

              this.go(this.index + 1);
            }, Math.max(3000, Number(this.dataset.delay) || 5000));
          }

          this.update();
        }

        go(index, animate = true) {
          this.index =
            (index + this.slides.length) % this.slides.length;

          this.track.scrollTo({
            left: this.slides[this.index].offsetLeft,
            behavior:
              animate && !this.reducedMotion.matches
                ? 'smooth'
                : 'auto'
          });

          this.update();
        }

        update() {
          this.dots.forEach((dot, index) => {
            if (index === this.index) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });

          this.slides.forEach((slide, index) => {
            slide.setAttribute(
              'aria-hidden',
              String(index !== this.index)
            );
          });

          if (this.playButton) {
            this.playButton.textContent =
              this.playing ? 'Pause' : 'Play';

            this.playButton.setAttribute(
              'aria-label',
              this.playing
                ? 'Pause automatic slideshow'
                : 'Start automatic slideshow'
            );
          }
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);
          clearInterval(this.timer);
          clearTimeout(this.scrollTimer);

          if (this.controller) {
            this.controller.abort();
          }

          if (this.resizeObserver) {
            this.resizeObserver.disconnect();
          }

          if (this.visibilityObserver) {
            this.visibilityObserver.disconnect();
          }

          this.controller = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["restored-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('restored-comparison')) {
    customElements.define('restored-comparison', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.events) this.events.abort();
        this.pointer = null;
      }

      initialize() {
        if (this.events) this.events.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.track = this.querySelector('[data-rc-track]');
        this.slides = Array.from(this.querySelectorAll('[data-rc-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-rc-go]'));
        this.status = this.querySelector('[data-rc-status]');
        this.index = Math.max(0, Math.min(this.index || 0, this.slides.length - 1));
        if (!this.track || !this.slides.length) return;

        this.querySelector('[data-rc-prev]').addEventListener('click', () => this.go(this.index - 1), options);
        this.querySelector('[data-rc-next]').addEventListener('click', () => this.go(this.index + 1), options);
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.go(index), options);
        });

        this.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);

        this.track.addEventListener('dragstart', (event) => event.preventDefault(), options);
        this.track.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || event.button !== 0 || this.slides.length < 2) return;
          this.pointer = {
            id: event.pointerId,
            x: event.clientX,
            y: event.clientY,
            slide: this.slides.indexOf(event.target.closest('[data-rc-slide]'))
          };
          this.track.setPointerCapture(event.pointerId);
        }, options);

        this.track.addEventListener('pointerup', (event) => {
          const start = this.pointer;
          if (!start || start.id !== event.pointerId) return;
          this.pointer = null;
          const dx = event.clientX - start.x;
          const dy = event.clientY - start.y;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
            this.go(this.index + (dx < 0 ? 1 : -1));
          } else if (Math.abs(dx) < 12 && Math.abs(dy) < 12 && start.slide >= 0) {
            this.go(start.slide);
          }
          if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        }, options);

        this.track.addEventListener('pointercancel', () => { this.pointer = null; }, options);
        this.track.addEventListener('lostpointercapture', () => { this.pointer = null; }, options);

        this.addEventListener('shopify:block:select', (event) => {
          const selected = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (selected >= 0) this.go(selected);
        }, options);

        this.go(this.index, false);
        this.classList.add('is-ready');
      }

      go(index, announce = true) {
        const count = this.slides.length;
        if (!count) return;
        this.index = ((index % count) + count) % count;

        this.slides.forEach((slide, position) => {
          let offset = (position - this.index + count) % count;
          if (offset > count / 2) offset -= count;
          const active = offset === 0;
          slide.style.setProperty('--rc-shift', (offset * 85) + '%');
          slide.style.setProperty('--rc-scale', active ? '1' : '0.8');
          slide.style.zIndex = active ? '10' : '1';
          slide.classList.toggle('is-active', active);
          slide.classList.toggle('is-neighbor', Math.abs(offset) === 1);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        this.dots.forEach((dot, position) => {
          dot.setAttribute('aria-current', position === this.index ? 'true' : 'false');
        });
        if (announce && this.status) {
          this.status.textContent = 'Comparison ' + (this.index + 1) + ' of ' + count;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rust-repair-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rust-repair-faq')) {
    customElements.define('rust-repair-faq', class extends HTMLElement {
      connectedCallback() {
        if (!window.Shopify || !window.Shopify.designMode || this.onBlockSelect) return;
        this.onBlockSelect = (event) => {
          const item = event.target.closest('details.rf-item');
          if (item && this.contains(item)) item.open = true;
        };
        this.addEventListener('shopify:block:select', this.onBlockSelect);
      }
      disconnectedCallback() {
        if (!this.onBlockSelect) return;
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.onBlockSelect = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
